<div class="suburb-list">
  <!-- Coverage funnel, over the same state / region / search as the table. -->
  <div *ngIf="funnel">
    <div class="funnel">
      <button type="button" class="step" [class.on]="!filters.status" (click)="showStatus(null)">
        <span class="n">{{ funnel.suburbs | number }}</span><span class="t">suburbs</span>
      </button>
      <span class="arrow">›</span>
      <div class="step static"><span class="n">{{ funnel.withData | number }}</span><span class="t">with crawl data</span></div>
      <span class="arrow">›</span>
      <button type="button" class="step" [class.on]="filters.status === 'assigned'" (click)="showStatus('assigned')">
        <span class="n">{{ funnel.assigned | number }}</span><span class="t">assigned to a region</span>
      </button>
      <span class="arrow">›</span>
      <button type="button" class="step" [class.on]="filters.status === 'covered'" (click)="showStatus('covered')">
        <span class="n">{{ funnel.covered | number }}</span><span class="t">covered</span>
      </button>
      <span class="arrow">›</span>
      <button type="button" class="step" [class.on]="filters.status === 'page'" (click)="showStatus('page')">
        <span class="n">{{ funnel.withPage | number }}</span><span class="t">with a page</span>
      </button>
    </div>
    <div class="candidates text-sm mt-2">
      <span class="text-600 mr-2">Candidates (assigned, not covered), by crawl richness:</span>
      <button *ngFor="let b of bucketsOf(funnel.candidatesByBucket)" type="button" class="chip" [class.on]="filters.status === 'candidates' && filters.bucket === b.bucket" (click)="showStatus('candidates', b.bucket)">
        <span class="bucket" [class]="'b-' + b.bucket">{{ b.bucket === 'none' ? 'no data' : b.bucket }}</span> {{ b.n | number }}
      </button>
      <span *ngIf="!funnel.dataset" class="text-600">No crawl dataset is loaded here, so there is no richness to show.</span>
      <button *ngIf="otherPages" type="button" class="chip ml-3" (click)="openOtherPages.emit()" pTooltip="Pages that aren't one suburb or a sub-region: places">{{ otherPages }} other pages</button>
    </div>
  </div>

  <div class="mt-3">
    <div>
      <div class="filters">
        <span class="p-input-icon-left search">
          <i class="pi pi-search"></i>
          <input pInputText type="search" placeholder="Suburb, SAL code or postcode" [(ngModel)]="filters.q" (ngModelChange)="onSearch()" />
        </span>
        <p-dropdown [baseZIndex]="12000" appendTo="body" [options]="states" [(ngModel)]="filters.state" (onChange)="reload()" placeholder="State" [showClear]="true"></p-dropdown>
        <p-dropdown [baseZIndex]="12000" appendTo="body" [options]="regionOptions" [(ngModel)]="filters.region" (onChange)="reload()" placeholder="Region" [showClear]="true"></p-dropdown>
        <p-dropdown *ngIf="subRegionFilter.length > 1" [baseZIndex]="12000" appendTo="body" [options]="subRegionFilter" [group]="true" optionLabel="label" optionValue="value"
                    [(ngModel)]="filters.subRegion" (onChange)="reload()" placeholder="Sub-region" [showClear]="true" styleClass="subregion-filter">
          <ng-template let-g pTemplate="group"><span class="text-600 text-sm">{{ g.label }}</span></ng-template>
        </p-dropdown>
        <p-dropdown [baseZIndex]="12000" appendTo="body" [options]="statuses" [(ngModel)]="filters.status" (onChange)="reload()" placeholder="Status" [showClear]="true"></p-dropdown>
        <p-dropdown [baseZIndex]="12000" appendTo="body" [options]="buckets" [(ngModel)]="filters.bucket" (onChange)="reload()" placeholder="Crawl richness" [showClear]="true"></p-dropdown>
        <button *ngIf="anyFilter" pButton type="button" class="p-button-text p-button-sm" label="Clear" (click)="resetFilters()"></button>
      </div>
      <div *ngIf="error" class="err text-sm mt-2">{{ error }}</div>

      <p-table [value]="rows" [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [paginator]="true" [rows]="pageSize" [totalRecords]="total" [first]="first"
               [loading]="loading" sortField="name" [sortOrder]="1" dataKey="salCode" styleClass="p-datatable-sm mt-3" [rowHover]="true" responsiveLayout="scroll"
               currentPageReportTemplate="{first}–{last} of {totalRecords}" [showCurrentPageReport]="true">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">Suburb <p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="state">State <p-sortIcon field="state"></p-sortIcon></th>
            <th pSortableColumn="region">Region <p-sortIcon field="region"></p-sortIcon></th>
            <th>Sub-regions</th>
            <th pSortableColumn="covered">Covered <p-sortIcon field="covered"></p-sortIcon></th>
            <th>Page</th>
            <th pSortableColumn="score" class="num">Crawl score <p-sortIcon field="score"></p-sortIcon></th>
            <th pSortableColumn="venueCount" class="num">Venues <p-sortIcon field="venueCount"></p-sortIcon></th>
            <th pSortableColumn="landmarkCount" class="num">Landmarks <p-sortIcon field="landmarkCount"></p-sortIcon></th>
            <th pSortableColumn="population" class="num">Population <p-sortIcon field="population"></p-sortIcon></th>
            <th pSortableColumn="areaKm2" class="num">km² <p-sortIcon field="areaKm2"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-r>
          <tr class="clickable" (click)="open.emit(r.salCode)">
            <td><span class="font-medium">{{ r.name }}</span><span class="text-500 text-xs ml-2">{{ r.postcode }}</span></td>
            <td>{{ r.state }}</td>
            <td>{{ regionName(r.regionId) || '—' }}</td>
            <td class="text-sm subregions">{{ subRegionList(r.subRegions) }}</td>
            <td><i *ngIf="r.covered" class="pi pi-check app-text-ok"></i></td>
            <td class="text-sm">{{ r.page || '' }}</td>
            <td class="num"><span *ngIf="r.bucket" class="bucket" [class]="'b-' + r.bucket">{{ r.bucket }}</span> {{ r.score ?? '' }}</td>
            <td class="num">{{ r.venueCount ?? '' | number }}</td>
            <td class="num">{{ r.landmarkCount ?? '' }}</td>
            <td class="num">{{ r.population ?? '' | number }}</td>
            <td class="num">{{ r.areaKm2 ?? '' | number: '1.0-1' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="11" class="text-600">No suburbs match.</td></tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
